import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'blush';
};
export function Testimonials({
  testimonials,
  title = 'What activity professionals are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-blush';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-266" data-mp="31zd1cduz1oe3">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-267" data-mp="3229024en8h3l">
        <div className="text-center" data-id="element-268" data-mp="2x1bk7yh3vz59">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-269" data-mp="2s1q8engu7wb4">
            Activity professional to activity professional
          </p>
          <h2 className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-270" data-mp="v8wvogk23wfv">
            {title}
          </h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-271" data-mp="h67xhyy0he7q">
              {subtitle}
            </p>}
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-272" data-mp="m5sxmcox3sm1">
          {testimonials.map((item, i) => <figure key={i} className="rounded-3xl border border-cream-dark bg-white p-5 shadow-card" data-id="element-273" data-mp="79le7elc2v7t" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-274" data-mp="zvwesp8xww4m">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-cream-dark" data-id="element-275" data-mp="14v9bs2tizjkx" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-plum font-display text-[13px] italic text-gold" data-id="element-276" data-mp="1iu8xp2pnlkde">
                    {item.author.replace(/[^A-Za-z ]/g, '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'MC'}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-277" data-mp="1ji7zpnt6bvuw">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-278" data-mp="1ejeknqy8nwsm" />)}
                </span>
              </div>
              <blockquote className="mt-3 font-display text-[15px] italic leading-relaxed text-ink" data-id="element-279" data-mp="14r8wytf0s1j8">
                {item.quote}
              </blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-280" data-mp="vrlrnwj66bkw">
                <span className="block text-[13px] font-semibold not-italic text-plum" data-id="element-281" data-mp="qtu1p8234zjc">
                  {item.author}
                </span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}